import {
  QueryClient,
  useMutation,
  useQueryClient
} from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { useInterval } from "react-use";
import api from "../services/api";
import { SAMPLE_REPORT_KEY } from "./useGetReportSummary";

type Payload = {
  sha1: string;
};

const REFETCH_COUNT = 5;
const REFETCH_INTERVAL = 15_000;

const mutationFn = ({ sha1 }: Payload) => api.reclassifySample(sha1);

const refetch = (client: QueryClient) =>
  client.invalidateQueries({
    predicate: query => query.queryKey.includes(SAMPLE_REPORT_KEY)
  });

const useReclassifySample = () => {
  const [refetchCount, setRefetchCount] = useState(REFETCH_COUNT);

  const queryClient = useQueryClient();

  useInterval(
    () => {
      refetch(queryClient);
      setRefetchCount(c => c - 1);
    },
    refetchCount > 0 ? REFETCH_INTERVAL : null
  );

  const { mutate } = useMutation({
    mutationKey: ["reclassifySample"],
    mutationFn,
    onSuccess: () => {
      setRefetchCount(REFETCH_COUNT);
    }
  });

  const reclassify = useCallback(
    (sha1: string) => {
      mutate({ sha1 });
    },
    [mutate]
  );

  return { reclassify };
};

export default useReclassifySample;
